import { defineMessage } from 'services/localization';

export const messages = {
    sectionHeaderText: defineMessage('items'),
    receivedColumnName: defineMessage('received'),
    receivedTooltip: defineMessage('received'),
    itemColumnName: defineMessage('item'),
    descriptionColumnName: defineMessage('description'),
    locationColumnName: defineMessage('location'),
    quantityColumnName: defineMessage('quantity'),
    quantityOnHandColumnName: defineMessage('quantity_on_hand'),
    quantityRemainingColumnName: defineMessage('quantity_remaining'),
    unitPriceColumnName: defineMessage('rate'),
    amountColumnName: defineMessage('amount'),
};
